import Share from '@/components/svg/Share';

type ShareThisArticleProps = {
  title: string;
  slug: string;
};

// prod: https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Fpress.fanduel.com%2Fpress-releases%2Fpress-release-details%2F2023%2FFANDUEL-TVS-RUN-IT-BACK-RUNS-IT-BACK-FOR-SEASON-2-WITH-NEW-CO-HOST-LOU-WILLIAMS%2Fdefault.aspx&linkname=FANDUEL%20TV%27S%20%22RUN%20IT%20BACK%22%20RUNS%20IT%20BACK%20FOR%20SEASON%202%20WITH%20NEW%20CO-HOST%20LOU%20WILLIAMS%20%7C%20FanDuel%20Inc.&linknote=
// dev: https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fcontentx-press-frontend.use1.pdm-dev.com%2Fpress-releases%2Ffanduel-tv-is-all-in-on-the-40th-breeders-cup
const ShareThisArticle = ({ title, slug }: ShareThisArticleProps) => {
  const ADD_TO_ANY = 'https://www.addtoany.com/share#url=';
  const encodedHref = encodeURIComponent(
    `https://press.fanduel.com/press-releases/${slug}`
  );

  return (
    <div
      data-testid='share-this-article'
      className='a2a_kit flex flex-nowrap justify-center'
      data-a2a-title={title}
    >
      <a
        className='a2a_dd text-content-link flex flex-nowrap items-center'
        href={`${ADD_TO_ANY}${encodedHref}`}
      >
        <Share width='24' height='24' />
        <span className='inline-block pl-2'>Share this article</span>
      </a>
    </div>
  );
};

export default ShareThisArticle;
